import { useLayoutEffect } from 'react';

export function scrollOnboardingToTop(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const main = document.getElementById('main');
  if (main) {
    main.scrollTop = 0;
  }
}

export function useOnboardingScrollTop(): void {
  useLayoutEffect(() => {
    scrollOnboardingToTop();
  }, []);
}
